const MessageContants = {
    COMPANY_CREATED: "Company created",
    COMPANY_UPDATED: "Company updated",
    COMPANY_ACTIVATE: "Company activated",
    COMPANY_DEACTIVATE: "Company de-activated",
    SCHOOL_CREATED: "School created",
    SCHOOL_UPDATED: "School updated",
    SCHOOL_ACTIVATE: "School activated",
    SCHOOL_DEACTIVATE: "School de-activated",
    STUDENT_CREATED: "Student created",
    STUDENT_UPDATED: "Student updated",
    STUDENT_TRANSPORT_DETAIL_CREATED: "Student transport detail created",
    STUDENT_TRANSPORT_DETAIL_UPDATED: "Student transport detail updated",
    ACADEMIC_YEAR_CREATED: "Financial year created",
    ACADEMIC_YEAR_UPDATED: "Financial year updated",
    ACADEMIC_YEAR_ACTIVATE: "Financial year activated",
    ACADEMIC_YEAR_DEACTIVATE: "Financial year de-activated",
    GROUP_CREATED: "Group created",
    GROUP_UPDATED: "Group updated",
    GROUP_ACTIVATE: "Group activated",
    GROUP_DEACTIVATE: "Group de-activated",
    LOCATION_CREATED: "Location created",
    LOCATION_UPDATED: "Location updated",
    LOCATION_ACTIVATE: "Location activated",
    LOCATION_DEACTIVATE: "Location de-activated",
    DEPARTMENT_CREATED: "Department created",
    DEPARTMENT_UPDATED: "Department updated",
    DEPARTMENT_ACTIVATE: "Department activated",
    DEPARTMENT_DEACTIVATE: "Department de-activated",
    USER_CREATED: "User created",
    USER_UPDATED: "User updated",
    USER_ACTIVATE: "User activated",
    USER_DEACTIVATE: "User de-activated",
    TRANSPORT_TYPE_CREATED: "Transport type created",
    TRANSPORT_TYPE_UPDATED: "Transport type updated",
    TRANSPORT_TYPE_ACTIVATE: "Transport type activated",
    TRANSPORT_TYPE_DEACTIVATE: "Transport type de-activated",
    FEES_TYPE_CREATED: "Fees type created",
    FEES_TYPE_UPDATED: "Fees type updated",
    FEES_TYPE_ACTIVATE: "Fees type activated",
    FEES_TYPE_DEACTIVATE: "Fees type de-activated",
    FEES_SETUP_CREATED: "Fees setup created",
    FEES_SETUP_UPDATED: "Fees setup updated",
    FEES_SETUP_ACTIVATE: "Fees setup activated",
    FEES_SETUP_DEACTIVATE: "Fees setup de-activated",
    TRANSACTION_CODE_SETUP_CREATED: "Transaction code setup created",
    TRANSACTION_CODE_SETUP_UPDATED: "Transaction code setup updated",
    TRANSACTION_CODE_SETUP_ACTIVATE: "Transaction code setup activated",
    TRANSACTION_CODE_SETUP_DEACTIVATE: "Transaction code setup de-activated",
    ZONE_CREATED: "Zone created",
    ZONE_UPDATED: "Zone updated",
    AREA_CREATED: "Area created",
    AREA_UPDATED: "Area updated",
    CLASS_PROMOTION_CREATED: "Class promotion created",
    CLASS_PROMOTION_UPDATED: "Class promotion updated",
    CLASS_PROMOTION_EXECUTED: "Class promotion executed",
    FINANCE_TRANSACTION_CODE_SETUP_CREATED: "Finance transaction code setup created",
    FINANCE_TRANSACTION_CODE_SETUP_UPDATED: "Finance transaction code setup updated",
    MODE_OF_PAY_CREATED: "Mode of pay created",
    MODE_OF_PAY_UPDATED: "Mode of pay updated",
    CURRENCY_CREATED: "Currency created",
    CURRENCY_UPDATED: "Currency updated",
    BUS_DETAIL_CREATED: "Bus detail created",
    BUS_DETAIL_UPDATED: "Bus detail updated",
    CUSTOMER_CREATED: "Customer created",
    CUSTOMER_UPDATED: "Customer updated",
    SUPPLIER_CREATED: "Supplier created",
    SUPPLIER_UPDATED: "Supplier created",
    ACCOUNT_LEDGER_CREATED: "Account ledger created",
    ACCOUNT_LEDGER_UPDATED: "Account ledger updated",
    BANK_DETAIL_CREATED: "Bank detail created",
    BANK_DETAIL_UPDATED: "Bank detail updated",
    CASH_LEDGER_CREATED: "Cash ledger created",
    CASH_LEDGER_UPDATED: "Cash ledger updated",
    GROUP_HEADER_CREATED: "Group header created",
    GROUP_HEADER_UPDATED: "Group header updated",
    MAIN_GROUP_CREATED: "Main group created",
    MAIN_GROUP_UPDATED: "Main group updated",
    SUB_ACCOUNT_CREATED: "Sub account created",
    SUB_ACCOUNT_UPDATED: "Sub account updated",
    ACCOUNT_CREATED: "Account created",
    ACCOUNT_UPDATED: "Account updated",
    INVOICE_HEADER_CREATED: "Invoice header created",
    INVOICE_HEADER_UPDATED: "Invoice header updated",
    INVOICE_LINE_CREATED: "Invoice line created",
    INVOICE_LINE_UPDATED: "Invoice line updated",
    RECEIPT_HEADER_CREATED: "Receipt header created",
    RECEIPT_HEADER_UPDATED: "Receipt header updated",
    RECEIPT_HEADER_DELETED: "Receipt header deleted",
    RECEIPT_LINE_CREATED: "Receipt line created",
    RECEIPT_LINE_UPDATED: "Receipt line updated",
    RECEIPT_LINE_DELETED: "Receipt Line deleted",
    GRADE_CREATED: "Class created",
    GRADE_UPDATED: "Class updated",
    TERM_CREATED: "Term created",
    TERM_UPDATED: "Term updated",
    MAIN_GROUP_LEDGER_CREATED: "Main group ledger created",
    MAIN_GROUP_LEDGER_UPDATED: "Main group ledger updated",
    MAIN_GROUP_LEDGER_ACCOUNT_CREATED: "Main group ledger account created",
    MAIN_GROUP_LEDGER_ACCOUNT_UPDATED: "Main group ledger account updated",
    JOURNAL_HEADER_CREATED: "Journal created",
    JOURNAL_HEADER_UPDATED: "Journal updated",
    INVOICE_GENERATES: "Invoice Generated",
    VOUCHER_CREATED: "Voucher created",
    VOUCHER_UPDATED: "Voucher updated",
    VOUCHER_DELETED: "Voucher deleted",
    VOUCHER_LINE_CREATED: "Voucher Line created",
    VOUCHER_LINE_UPDATED: "Voucher Line updated",
    VOUCHER_LINE_DELETED: "Voucher Line deleted",
    DEBIT_NOTE_CREATED: "Debit note created",
    DEBIT_NOTE_UPDATED: "Debit note updated",
    DEBIT_NOTE_LINE_CREATED: "Debit note Line created",
    DEBIT_NOTE_LINE_UPDATED: "Debit note Line updated",
    DEBIT_NOTE_LINE_DELETED: "Debit note Line deleted",
    CREDIT_NOTE_CREATED: "Credit note created",
    CREDIT_NOTE_UPDATED: "Credit note updated",
    CREDIT_NOTE_LINE_CREATED: "Credit note Line created",
    CREDIT_NOTE_LINE_UPDATED: "Credit note Line updated",
    CREDIT_NOTE_LINE_DELETED: "Credit note Line deleted",
    NO_ACADEMIC_YEAR_IN_SCHOOL: "Academic year not linked with school",
    NO_CREDIT_LEDGER_IN_SCHOOL: "Credit account not linked with school",
    DISCOUNT_CREATED: "Discount created",
    DISCOUNT_UPDATED: "Discount updated",
};

export default MessageContants;